<template>
  <div id="group-search">
    <b-row>
      <b-col>
        <b-form @submit.prevent="searchGroup">
          <b-form-group>
            <b-input-group>
              <b-form-input
                name="group"
                type="text"
                :id="parent + '-search'"
                v-model="group"
                placeholder="Search by group name"
              ></b-form-input>
              <b-input-group-append>
                <b-button
                  :disabled="group.length < 3"
                  type="submit"
                  variant="primary"
                  >Search</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-form>
        <p class="error" v-if="group.length < 3">
          Please enter at least three characters to search
        </p>
        <p v-if="loading">Loading...</p>
        <p v-if="error">No matching {{table}} were found. Please search again</p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'GroupSearch',
  props: {
    table: String,
  },
  methods: {
    ...mapActions({
      SEARCH_STUDENTS: 'searches/GET_STUDENTS_BY_GROUP',
      SEARCH_TEACHERS: 'searches/GET_TEACHERS_BY_GROUP',
      RESET_SEARCH: 'searches/RESET_SEARCH_STATE',
    }),
    stopClick(row) {},
    async searchGroup() {
      if (this.table === 'students') {
        await this.SEARCH_STUDENTS();
      }
      if (this.table === 'teachers') {
        await this.SEARCH_TEACHERS();
      }
    },
  },
  computed: {
    group: {
      get() {
        return this.$store.state.searches.group;
      },
      set(val) {
        this.$store.commit('searches/group', val);
      },
    },
    ...mapGetters({
      loading: 'searches/getLoading',
      error: 'searches/getError',
    }),
  },
  destroyed() {
    this.RESET_SEARCH();
  },
};
</script>

<style scoped>
.location-underline {
  text-decoration: underline;
}
</style>
